var AccOrdersPage = {};

AccOrdersPage.init = function () {
  $('.orders_table > .table-body > .item').each(function (i, element) {
    new AccOrder(element);
  });
};

$(AccOrdersPage.init);

function AccOrder(element) {
  var self = this;

  this.selected = [];
  this.order = {
    _id: element.getAttribute("data-id")
  };
  this.$element = $(element);

  this.selectProduct = function (canReturnUntil, pos, hasEngrave) {
    self.selected.push({
      pos: pos,
      canReturnUntil: new Date(canReturnUntil),
      hasEngrave: hasEngrave
    });
    this.updateButtons();
  };

  this.deselectProduct = function (pos) {
    var index = self.selected.findIndex(function (item) {
      return item.pos === pos;
    });
    if (index > -1) {
      self.selected.splice(index, 1);
    }
    this.updateButtons();
  };

  this.updateButtons = function () {
    var now = new Date();

    if (self.selected.length && self.selected.every(function (item) { return item.canReturnUntil > now; })) {
      this.$element.find('button.item-return').removeClass('hidden');
    } else {
      this.$element.find('button.item-return').addClass('hidden');
    }

    if (self.selected.length) {
      this.$element.find('button.item-reclamation').removeClass('hidden');
    } else {
      this.$element.find('button.item-reclamation').addClass('hidden');
    }

  };

  this.$element.find('input[type=checkbox]').click(function () {
    if ($(this).is(':checked')) {
      self.selectProduct($(this).attr('data-return-until'), $(this).attr('data-pos'), $(this).attr('data-has-engrave'));
    } else {
      self.deselectProduct($(this).attr('data-pos'));
    }
  });

  this.$element.find('button.item-return').click(function (e) {
    if (self.selected.find(function(item){ return item.hasEngrave === "true"; })) {
      e.preventDefault();
      $('#cantReturnEngravedItemsModal').popup('show');
    }
  });
}